import { render, staticRenderFns } from "./PostContentTemplateEditor.vue?vue&type=template&id=4cf28324"
import script from "./PostContentTemplateEditor.vue?vue&type=script&lang=js"
export * from "./PostContentTemplateEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports